// extracted by mini-css-extract-plugin
export default {"thumbsIcon":"Feedback_thumbsIcon__kWBMO","thumbsIconActive":"Feedback_thumbsIconActive__I+qla"};